/* Real calendar validation for the optional MM/DD/YYYY registration field.
   This enhances Shopify's native contact form; it never submits or simulates a result. */
(() => {
  if (window.dtRegistrationCalendar) {
    window.dtRegistrationCalendar.init(document);
    return;
  }

  const initialized = new WeakSet();
  const formatMessage = 'Enter a real date in MM/DD/YYYY format, or leave this optional field blank.';
  const calendarMessage = 'That date does not exist. Check the month, day and year.';

  function dateError(value) {
    if (value === '') return '';
    const parts = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/([0-9]{4})$/.exec(value);
    if (!parts) return formatMessage;
    const month = Number(parts[1]);
    const day = Number(parts[2]);
    const year = Number(parts[3]);
    if (year < 1) return 'Enter a year from 0001 to 9999.';
    const leapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const days = [31, leapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return day > days[month - 1] ? calendarMessage : '';
  }

  function init(root) {
    const fields = [...root.querySelectorAll('[data-dt-registration-date]')];
    if (root.matches?.('[data-dt-registration-date]')) fields.unshift(root);
    for (const field of fields) {
      if (initialized.has(field)) continue;
      initialized.add(field);
      const error = field.closest('.dt-registration__field')?.querySelector('.dt-registration__date-error');
      if (!error) continue;
      let showError = false;

      function validate(show = showError) {
        const message = dateError(field.value);
        field.setCustomValidity(message);
        if (show && message) {
          error.textContent = message;
          error.hidden = false;
          field.setAttribute('aria-invalid', 'true');
        } else {
          error.textContent = '';
          error.hidden = true;
          field.removeAttribute('aria-invalid');
        }
        return !message;
      }

      field.addEventListener('input', () => validate());
      field.addEventListener('change', () => validate());
      field.addEventListener('blur', () => {
        showError = true;
        validate(true);
      });
      field.addEventListener('invalid', () => {
        showError = true;
        validate(true);
      });
      field.form?.addEventListener('reset', () => {
        showError = false;
        window.setTimeout(() => validate(false), 0);
      });
      // Restored values and programmatic edits must be checked before native submission.
      field.form?.addEventListener('submit', event => {
        if (!validate(true)) {
          event.preventDefault();
          field.focus();
        }
      });
      validate(false);
    }
  }

  window.dtRegistrationCalendar = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
